import React from 'react'
import { useThemeMediaQuery } from 'hooks/useThemeMediaQuery'
import { Button, Flex, Text, TextVariant } from '@mprolab/uikit'
import MainWrapper from 'layouts/MainWrapper'
import { StyledBiennale } from 'components'
import styled, { useTheme } from 'styled-components'
import Image from 'components/CompatImage'
import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'react-feather'
import { useRouter } from 'hooks/useRouter'

import gradientRound from '../../public/images/gradientRound.webp'
import dottedBackground from '../../public/images/dottedBackgroundPattern1.webp'

const StyledTitle = styled(StyledBiennale)`
  font-size: 40px;
  line-height: 44px;
  ${({ theme }) => theme.mediaQueries.tablet} {
    font-size: 32px;
  }
`

const DottedBackgroundWrapper = styled(Flex)`
  position: absolute;
  top: -150px;
  left: 70px;
  width: 100%;
  height: 700px;
  z-index: -1;

  ${({ theme }) => theme.mediaQueries.tablet} {
    height: 550px;
    left: 0;
    left: 80px;
  }
`

const ContentBox = styled(Flex)`
  position: relative;
  width: 100%;
  max-width: 464px;
  padding: 40px;
  background: ${({ theme }) => theme.colors.backgroundContrast};
  gap: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const PageNumberWrapper = styled(Flex)`
  padding: 4px 12px;
  border-radius: 32px;
  background: rgba(3, 245, 255, 0.3);
  border: 1px solid ${({ theme }) => theme.colors.cyan};
`

const AbsoluteGradient = styled(Flex)<{ opposite?: boolean }>`
  position: absolute;
  left: 200px;

  left: ${({ opposite }) => (opposite ? '-200px' : 'auto')};
  bottom: ${({ opposite }) => (opposite ? '-200px' : 'auto')};
  right: ${({ opposite }) => (opposite ? 'auto' : '-200px')};
  top: ${({ opposite }) => (opposite ? 'auto' : '-200px')};
  z-index: -1;
`

const NoFound: React.FC = () => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  const { push } = useRouter()
  const isMobile = useThemeMediaQuery('mobile')

  return (
    <MainWrapper>
      <Flex fullWidth mt={isMobile ? '144px' : '244px'} mb="234px" justifyContent="center" alignItems="center">
        <ContentBox>
          <PageNumberWrapper>
            <Text variant={TextVariant.BODY_SMALL}>404</Text>
          </PageNumberWrapper>
          <Flex flexDirection="column" gap="16px">
            <StyledTitle textAlign="center">{t('404.title')}</StyledTitle>
            <Text textAlign="center" color={colors.gray3}>
              {t('404.description')}
            </Text>
          </Flex>
          <Button onClick={() => push('/')} endIcon={<ArrowRight color={colors.white} />}>
            {t('404.buttonCTA')}
          </Button>
          <AbsoluteGradient>
            <Image src={gradientRound} objectFit="cover" loading="eager" />
          </AbsoluteGradient>
          <AbsoluteGradient opposite>
            <Image src={gradientRound} objectFit="cover" loading="eager" />
          </AbsoluteGradient>
        </ContentBox>
      </Flex>
      <DottedBackgroundWrapper>
        <Image src={dottedBackground} objectFit="cover" loading="eager" />
      </DottedBackgroundWrapper>
    </MainWrapper>
  )
}

export default NoFound
